import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import './GalleryPage.css';
import SpecialGiftSequence from './SpecialGiftSequence';
import { simplyYouPhotos } from './simplyYouPhotos';
import { youAndMePhotos } from './youAndMePhotos';
import { youAndDadaPhotos } from './youAndDadaPhotos';
import { theGangPhotos } from './theGangPhotos';

const TIMELINE_EVENTS = [
  { title: 'Some people search their whole lives to find what I see in your smile.', img: '/imges/anu%20photo1.jpg' },
  { title: 'I love you more than words can describe, more than numbers can count, and more than the universe can hold.', img: '/imges/anu%20photo2.png' },
  { title: 'If stars could speak, they’d tell you how much I talk about you.', img: '/imges/anu%20photo3.jpg' },
  { title: 'Thank you for being the beautiful reality of my favorite dreams.', img: '/imges/anu%20photo4.jpg' }
];

const ALBUMS = [
  { id: 'solo', title: 'Simply You', desc: 'Radiant and beautiful', src: '/imges/simply%20you.jpg' },
  { id: 'us', title: 'You & Me', desc: 'Partners in crime', src: '/imges/You%20and%20me.jpg' },
  { id: 'dada', title: 'You & Dada', desc: 'Family bonds forever', src: '/imges/You%20and%20dada.jpg' },
  { id: 'gang', title: 'The Gang', desc: 'Unforgettable memories', src: '/imges/The%20gange.jpg' }
];

const PHOTOS = [
  // { id: 1, album: 'solo', src: 'https://images.unsplash.com/photo-1490750967868-88df5691cc1c?w=900&q=85', title: 'Spring Bloom', caption: 'Every petal, just like you', audioSrc: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3' },
  // { id: 2, album: 'us', src: 'https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=900&q=85', title: 'Morning Glow', caption: 'You shine brighter than the sun' },
  // { id: 3, album: 'gang', src: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=900&q=85', title: 'Soft Grace', caption: 'Elegant in every moment' },
  // { id: 4, album: 'solo', src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=900&q=85', title: 'Cloud Drift', caption: 'Floating in your dreamy world' },
  // { id: 5, album: 'solo', src: 'https://images.unsplash.com/photo-1444313431167-e7921088a9d3?w=900&q=85', title: 'Wild Garden', caption: 'Beautiful and free' },
  // { id: 6, album: 'us', src: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=900&q=85', title: 'Golden Light', caption: 'Luminous from within' },
  // { id: 7, album: 'gang', src: 'https://images.unsplash.com/photo-1519415943484-9fa1873496d4?w=900&q=85', title: 'Pearl & Silk', caption: 'Timeless and radiant' },
  // { id: 8, album: 'solo', src: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?w=900&q=85', title: 'Azure Sky', caption: 'Endless as the sky above' },
  // { id: 9, album: 'solo', src: 'https://images.unsplash.com/photo-1508610048659-a06b669e3321?w=900&q=85', title: 'Rose Whisper', caption: 'Soft petals, softer heart' },
  // { id: 10, album: 'us', src: 'https://images.unsplash.com/photo-1552693673-1bf958298935?w=900&q=85', title: 'Natural Beauty', caption: 'No filter ever needed' },
  // { id: 11, album: 'gang', src: 'https://images.unsplash.com/photo-1599733594230-6b823276d4b8?w=900&q=85', title: 'Golden Poise', caption: 'Grace in every step' },
  // { id: 12, album: 'solo', src: 'https://images.unsplash.com/photo-1418065460487-3e41a6c84dc5?w=900&q=85', title: 'Misty Morning', caption: 'Calm, serene, and all yours' },
  { id: 13, album: 'us', src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=', title: 'A Secret Dance', caption: 'Click to reveal something special...', isVideo: true, isYoutube: true, videoId: 'Do-2iNljUQA' },
  ...simplyYouPhotos,
  ...youAndMePhotos,
  ...youAndDadaPhotos,
  ...theGangPhotos
];

export default function GalleryPage({ onLogout }) {
  const [activeAlbum, setActiveAlbum] = useState(null); // null means Home view
  const [lightbox, setLightbox] = useState(null);
  const [visiblePhotos, setVisiblePhotos] = useState([]);
  const [ready, setReady] = useState(false);
  const [confetti, setConfetti] = useState([]);
  const [typedTitle, setTypedTitle] = useState('');

  // Easter Egg states
  const [heartClicks, setHeartClicks] = useState(0);
  const [activeVideo, setActiveVideo] = useState(null); // 'singing', 'words'
  const [, setTypedWord] = useState('');

  // Audio state
  const [isPlayingMusic, setIsPlayingMusic] = useState(true);
  const bgAudioRef = useRef(null);
  const voiceAudioRef = useRef(null);

  const fullTitle = "Happy Birthday, My Love.";

  const filteredPhotos = useMemo(() => {
    if (!activeAlbum) return [];
    let arr = PHOTOS.filter(p => p.album === activeAlbum);
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }, [activeAlbum]);

  useEffect(() => {
    setTimeout(() => setReady(true), 100);

    // Generate Confetti
    const colors = ['#f5c2d0', '#87c4e4', '#ffffff', '#fae6ea'];
    setConfetti(Array.from({ length: 60 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: colors[Math.floor(Math.random() * colors.length)],
      size: 6 + Math.random() * 8,
      delay: Math.random() * 5,
      duration: 5 + Math.random() * 5,
    })));

    // Typewriter effect
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < fullTitle.length) {
        setTypedTitle(fullTitle.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typingInterval);
      }
    }, 120);

    return () => clearInterval(typingInterval);
  }, []);

  // Handle music auto-play on mount
  useEffect(() => {
    if (bgAudioRef.current) {
      bgAudioRef.current.volume = 0.3; // keep it soft
      // We assume user clicked "Open" so autoplay policy should allow
      bgAudioRef.current.play().catch(e => console.log('Autoplay blocked', e));
    }
  }, []);

  // Keyboard Easter Egg ("LOVE")
  useEffect(() => {
    const handleTyping = (e) => {
      if (e.key.length === 1 && e.key.match(/[a-zA-Z]/)) {
        setTypedWord(prev => {
          const newWord = (prev + e.key).slice(-4);
          if (newWord.toLowerCase() === 'love') {
            setActiveVideo('words');
            if (bgAudioRef.current) bgAudioRef.current.pause();
            setIsPlayingMusic(false);
          }
          return newWord;
        });
      }
    };
    window.addEventListener('keydown', handleTyping);
    return () => window.removeEventListener('keydown', handleTyping);
  }, []);

  const handleHeartClick = () => {
    setHeartClicks(prev => {
      const newCount = prev + 1;
      if (newCount === 3) {
        setActiveVideo('singing');
        if (bgAudioRef.current) bgAudioRef.current.pause();
        setIsPlayingMusic(false);
        return 0;
      }
      return newCount;
    });
  };

  const toggleMusic = () => {
    if (bgAudioRef.current) {
      if (isPlayingMusic) {
        bgAudioRef.current.pause();
      } else {
        bgAudioRef.current.play();
      }
      setIsPlayingMusic(!isPlayingMusic);
    }
  };

  // Staggered grid reveal when opening an album
  useEffect(() => {
    if (activeAlbum) {
      setVisiblePhotos([]);
      filteredPhotos.forEach((_, i) => {
        setTimeout(() => setVisiblePhotos(prev => [...prev, i]), i * 80);
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [activeAlbum]); // eslint-disable-line

  const openLightbox = (photo) => setLightbox(photo);
  const closeLightbox = useCallback(() => {
    setLightbox(null);
    if (voiceAudioRef.current) {
      voiceAudioRef.current.pause();
      voiceAudioRef.current.currentTime = 0;
    }
  }, []);

  const navigateLb = useCallback((dir) => {
    if (voiceAudioRef.current) voiceAudioRef.current.pause();
    setLightbox(prev => {
      const idx = filteredPhotos.findIndex(p => p.id === prev.id);
      const next = (idx + dir + filteredPhotos.length) % filteredPhotos.length;
      return filteredPhotos[next];
    });
  }, [filteredPhotos]);

  // Keyboard navigation for Lightbox
  useEffect(() => {
    if (!lightbox) return;
    const handle = (e) => {
      if (e.key === 'ArrowRight') navigateLb(1);
      if (e.key === 'ArrowLeft') navigateLb(-1);
      if (e.key === 'Escape') closeLightbox();
    };
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, [lightbox, navigateLb, closeLightbox]);

  const playVoiceNote = (e, src) => {
    e.stopPropagation();
    if (voiceAudioRef.current) {
      voiceAudioRef.current.src = src;
      voiceAudioRef.current.play();
    }
  };

  return (
    <div className="gallery-bg">
      {/* Background Audio */}
      {/* Using a dummy stock audio link for background. Replace later. */}
      <audio ref={bgAudioRef} src="https://cdn.pixabay.com/download/audio/2022/10/25/audio_2c943fc33d.mp3?filename=soft-piano-113149.mp3" loop />
      <audio ref={voiceAudioRef} />

      {/* Floating Music Button */}
      <button className={`music-btn ${isPlayingMusic ? 'playing' : ''}`} onClick={toggleMusic} aria-label="Toggle Music">
        {isPlayingMusic ? '🔊' : '🔇'}
      </button>

      {/* Confetti Overlay */}
      {confetti.map(c => (
        <div key={c.id} className="confetti" style={{
          left: `${c.left}vw`,
          width: `${c.size}px`, height: `${c.size}px`,
          backgroundColor: c.color,
          borderRadius: Math.random() > 0.5 ? '50%' : '2px',
          animationDelay: `${c.delay}s`,
          animationDuration: `${c.duration}s`,
          opacity: 0.7
        }} />
      ))}

      {/* Header */}
      <header className={`gallery-header ${ready ? 'gallery-header--in' : ''}`}>
        <div className="header-brand" onClick={() => setActiveAlbum(null)} style={{ cursor: 'pointer' }}>
          <span className="brand-dot" />
          <span className="brand-name">For You</span>
        </div>
        <p className="header-tagline">✦ A gallery crafted with love ✦</p>
        <button className="logout-btn" onClick={onLogout}>Close Gift</button>
      </header>

      {!activeAlbum ? (
        // ================= HOME VIEW =================
        <div className="home-view">
          {/* Hero */}
          <section className="hero">
            <span className="hero-eyebrow">A Special Day 🎂</span>
            <h1 className="hero-title">
              {typedTitle}
              {typedTitle.length < fullTitle.length && <span className="typewriter-cursor"></span>}
              <br /><em>Simply Beautiful</em>
            </h1>
            <p className="hero-sub">
              Not just a gallery, but a collection of moments that make you, you. Every image here holds a piece of how I see you — radiant, gentle, and endlessly wonderful. This place was made just for you.
            </p>
            <div className="hero-line">
              <span className="hero-line__bar" />
              <span className="hero-line__icon">❧</span>
              <span className="hero-line__bar" />
            </div>
          </section>

          {/* Timeline Section */}
          <section className="timeline-section">
            <h2 className="section-title">With Love</h2>
            <div className="timeline">
              {TIMELINE_EVENTS.map((ev, i) => (
                <div key={ev.year} className={`timeline-item ${i % 2 === 0 ? 'left' : 'right'}`}>
                  <div className="timeline-content">
                    <span className="timeline-year">{ev.year}</span>
                    <h3 className="timeline-title">{ev.title}</h3>
                    <p className="timeline-desc">{ev.desc}</p>
                  </div>
                  <div className="timeline-img">
                    <img src={ev.img} alt={ev.title} />
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* 3 Albums Section */}
          <section className="albums-section">
            <h2 className="section-title">The Memories</h2>
            <div className="albums-grid">
              {ALBUMS.map(album => (
                <div key={album.id} className="album-card" onClick={() => setActiveAlbum(album.id)}>
                  <img src={album.src} alt={album.title} />
                  <div className="album-overlay">
                    <h3 className="album-title">{album.title}</h3>
                    <p className="album-desc">{album.desc}</p>
                    <span className="album-btn">Open Album</span>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      ) : (
        // ================= ALBUM VIEW =================
        <div className="album-view">
          <div className="album-header">
            <button className="back-btn" onClick={() => setActiveAlbum(null)}>← Back to Story</button>
            <h2 className="current-album-title">{ALBUMS.find(a => a.id === activeAlbum)?.title}</h2>
          </div>

          <main className="gallery-grid">
            {filteredPhotos.map((photo, i) => (
              <article
                key={photo.id}
                className={`photo-card ${visiblePhotos.includes(i) ? 'photo-card--in' : ''}`}
                style={{ transitionDelay: `${i * 30}ms` }}
                onClick={() => openLightbox(photo)}
              >
                <div className="photo-img-wrap">
                  <img src={photo.src} alt={photo.title} loading="lazy" />
                  <div className="photo-overlay">
                    <span className="overlay-expand">⤢</span>
                    {photo.audioSrc && (
                      <button className="voice-btn" onClick={(e) => playVoiceNote(e, photo.audioSrc)}>
                        🎤 Play Voice Note
                      </button>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </main>
        </div>
      )}

      {/* Footer */}
      <footer className="gallery-footer">
        <p>
          Made with{' '}
          <span className="heart" onClick={handleHeartClick} style={{ cursor: 'pointer' }} title="Click 3 times">♥</span>
          {' '}just for you — Happy Birthday! 🎂
        </p>
      </footer>

      {/* Lightbox */}
      {lightbox && (
        <div className="lightbox" onClick={closeLightbox}>
          <div className="lightbox-card" onClick={e => e.stopPropagation()}>
            <button className="lb-close" onClick={closeLightbox}>✕</button>
            <button className="lb-arrow lb-prev" onClick={() => navigateLb(-1)}>‹</button>

            <div className="lb-img-wrap">
              {lightbox.isVideo ? (
                lightbox.isYoutube ? (
                  <iframe 
                    src={`https://www.youtube.com/embed/${lightbox.videoId}?autoplay=1&rel=0`}
                    title="YouTube video player" frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen className="lb-video"
                    style={{ width: '100%', height: '50vh', minHeight: '300px', backgroundColor: 'black' }}
                  ></iframe>
                ) : (
                  <video src={lightbox.videoSrc} controls autoPlay className="lb-video" />
                )
              ) : (
                <img src={lightbox.src} alt={lightbox.title} />
              )}
            </div>

            <button className="lb-arrow lb-next" onClick={() => navigateLb(1)}>›</button>

            <div className="lb-info">
              {lightbox.audioSrc && (
                <button className="lb-voice-btn" onClick={(e) => playVoiceNote(e, lightbox.audioSrc)}>
                  🎤 Play Voice Note
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Easter Egg Video Modal - Singing */}
      {activeVideo && activeVideo !== 'words' && (
        <div className="video-modal" onClick={() => setActiveVideo(null)}>
          <div className="video-container" onClick={e => e.stopPropagation()}>
            <button className="close-video-btn" onClick={() => setActiveVideo(null)}>✕</button>
            <iframe
              src={`https://www.youtube.com/embed/73z54Qey4cI?autoplay=1&rel=0`}
              title="YouTube video player" frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen className="easter-egg-video"
              style={{ width: '90vw', height: '50vw', maxWidth: '800px', maxHeight: '450px', backgroundColor: 'black' }}
            ></iframe>
          </div>
        </div>
      )}

      {/* Easter Egg - Special PDF sequence for LOVE keyword */}
      {activeVideo === 'words' && (
        <SpecialGiftSequence onClose={() => setActiveVideo(null)} />
      )}
    </div>
  );
}
